export const pageAnimation = {
  before: {
    opacity: 0,
    x: 80,
  },
  after: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
  exit: {
    opacity: 0,
    x: 80,
  },
};

export const titleAnim = {
  before: { opacity: 0, y: 40 },
  after: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
};

export const titleAnim2 = {
  before: { opacity: 0, y: 40 },
  after: {
    opacity: 1,
    y: 0,
    transition: { duration: 1, delay: 1, ease: "easeOut" },
  },
};

export const descAnime = {
  before: { opacity: 0 },
  after: {
    opacity: 1,
    transition: { duration: 1, delay: 2 },
  },
};

export const imageAnime = {
  before: { scale: 0 },
  after: { scale: 1, transition: { duration: 1 } },
};

export const blobAnim = {
  before: {
    scale: 0,
  },
  after: {
    scale: 1,
    transition: {
      duration: 1,
      delay: 3,
    },
  },
};
export const frameAnim = {
  before: {
    x: "-110%",
    skew: "45deg",
  },
  after: {
    x: "100%",
    skew: "0deg",
    transition: { duration: 1.4, ease: "easeIn" },
  },
};
export default pageAnimation;
